import React from 'react'

export default class Contact extends React.Component {

  getIconSizeClassName () {
    let iconSizeClassName = "";
    switch (this.props.iconSize) {
      case "m" :
        iconSizeClassName = "is-medium"
        break;
      case "l" :
        iconSizeClassName = "is-large"
        break;
      default:
        iconSizeClassName = "is-medium"
        break;
    }
    return iconSizeClassName
  }

  render () {
    return (
      <a href={ this.props.link} className={`${this.props.label? 'subtitle is-6' : 'control'}`} target="_blank" rel="noopener noreferrer">
        <span className={`icon ${this.getIconSizeClassName()}`}>
          <i className={ this.props.iconClass } aria-hidden="true"></i>
        </span>
        { this.props.label }
      </a>
    )
  }
}